var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"sidebar-nav"},[_c('MySidebarChildren',{staticClass:"nav",attrs:{"nav-items":_vm.navItemsComputed},on:{"update:navItems":function($event){_vm.navItemsComputed=$event},"update:nav-items":function($event){_vm.navItemsComputed=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }